// extracted by mini-css-extract-plugin
export default {"link":"eN-z","disabled":"fN-z"};